import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _loadingCount = 0;
  readonly isLoading = signal<boolean>(false);

  show() {
    this._loadingCount++;
    this.isLoading.set(true);
  }

  hide() {
    this._loadingCount = Math.max(0, this._loadingCount - 1);
    if (this._loadingCount === 0) {
      this.isLoading.set(false);
    }
  }
}